import styled from "styled-components";

export const SAddNewItemModal = styled.div`
  width: 530px;
`;
